import '@fancyapps/fancybox'
import homeSearch from './scripts/home-search'
import homeCarousel from './scripts/home-carousel'
import homeSlide from './scripts/home-slide'
import { homeGallerySlide } from './scripts/logo-slider'
import homeMap from './scripts/home-map'

homeSearch()
homeCarousel()
homeSlide()
homeGallerySlide()
homeMap()
